/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__backfollow */
function tpl__backfollow() {
    return '<div class="backfollow__main"><div class="backfollow__header"><div class="backfollow__logo"></div><div class="backfollow__title">想看资讯</div><div class="backfollow__desc">看资讯，得现金，新用户当日可提现</div></div><div class="backfollow__open"><div class="backfollow__bg"></div><div class="backfollow__btn" >打开想看</div></div></div>';
}

exports.tpl__backfollow = tpl__backfollow;
